
import styles from "./chatAudioInner.module.scss";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import React, { useState } from "react";
import 'react-h5-audio-player/lib/styles.css';
import _ from "lodash";
import { useSelector } from "react-redux";
import { LoginState, initialStateModel } from "../../../../models/model";
import wavethumbnail from "../../../../styles/images/wave-thumbnail.svg";
type audioTypeProps = {
  data: any;
  userDetails: any;
  hoverdata?: any;
}
export default function ChatAudioInner({ data, userDetails, hoverdata }: audioTypeProps) {
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [visible, setVisible] = useState(false);
  try {
    const messageBody = _.isObject(data.message.body) ? data.message.body : JSON.parse(data.message.body);
    let filePath = messageBody?.filePath;
    //console.log("daatttttt", data)

    let { fromcaller_details } = data;
    let sip = fromcaller_details?.caller_id === loginDetails.userdetails.caller_id ? 2 : 1;
   
    const audioPlay = (e: any) => {

      var audios: any = document.querySelectorAll('audio');
      audios.forEach((element: any) => {
        if (element?.pause) {
          if (e.target.currentSrc === element?.src) {
            element.play();
            setVisible(true);
          } else {
            element.pause();
          }
        }
      });

    }

    
    let durRHAP:any = visible ? RHAP_UI.CURRENT_TIME: RHAP_UI.DURATION
    return (
      <>

        <div className={`chatInnerAudio ${styles.audioChat} ${data?.message?.isReply?"replyAudioType":""}`}>
          <div className={styles.audioImage}>
            <div className={styles.convIcon}>
              
              {messageBody?.fileName === "me-at-thevoice.mp3" && <div className={`lefts size40 colorBG${sip}`}>
                {fromcaller_details?.ImageURL &&
                  fromcaller_details?.sip_login_id !== loginDetails.userdetails.sip_login_id ?
                  <img src={fromcaller_details?.ImageURL} alt=""></img> :
                  loginDetails.userdetails.profile_url &&
                    fromcaller_details?.sip_login_id === loginDetails.userdetails.sip_login_id ?
                    <img src={loginDetails.userdetails.profile_url} alt=""></img> :
                    <span>{fromcaller_details?.caller_id?.charAt(0).toUpperCase()}</span>}

              </div>}
              {messageBody?.fileName !== "me-at-thevoice.mp3" && <div className={`lefts size40 colorBG${sip}`}>
                <img src={wavethumbnail} alt=""></img>

              </div>}
            </div>
          </div>
          <div className={styles.audioDetails}>
            <div className="audioNew">

              <AudioPlayer
                src={filePath}
                className='soundplay'
                autoPlay={false}
                autoPlayAfterSrcChange={false}
                onPlay={(e: any) => audioPlay(e)}
                customIcons={{
                  play: <span className="icon_play"></span>,
                  pause: <span className="icon_pausebar"></span>
                }}
                customProgressBarSection={
                  [ 
                    RHAP_UI.MAIN_CONTROLS,
                    RHAP_UI.PROGRESS_BAR,
                    durRHAP
                  ]
                }
                customControlsSection={
                  [
                    <div key={data.id}></div>
                  ]
                }
              />
              {/* <span className="audiotag">Audio</span> */}

            </div>

          </div>
          {/* <div className={styles.attachmentHover} id={"hover" + data.id}>
            <ChatAttachmentsOption data={data} overAllFileData={data} fromFiles={false} previewopen={onclickgetId} hoverdata={hoverdata} />
          </div> */}
        </div>
      </>
    );
  } catch (e) {
    return <p style={{ color: 'red' }}>Something went wrong</p>;
  }
};
